import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useEffect } from 'react';
import { useState } from 'react';
import Header from "./header.tsx"
import Prefooter from "./prefooter.js"
import Footer from "./footer.tsx"
import { Pane } from 'evergreen-ui';


const Layout = ({ children }) => {
  const [isScroling, setIsScroling] = useState(false);
  
  useEffect(() => {
	 const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScroling(true);
      } else {
        setIsScroling(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
	
	
  }, []);
	
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Pane>
	  <Pane borderBottom={isScroling && "1px solid #0b373c1a"} className={isScroling == true ? "z-50 transition-all duration-100 bg-white" :  "z-50 transition-all duration-100 mainback"} position="fixed" right={0} left={0}>
		<Header isScrol={isScroling} />
	  </Pane>
      <div>
        {children}
      </div>
	  <Prefooter />
	  <Pane className="mainback">
		<Footer />
	  </Pane>
    </Pane>
  )
}

export default Layout
